<template>
  <div>
    <!-- 线下诊断--诊断详情 -->
    <div style="background-color: white">
      <div style="display: flex;position: relative;">
        <el-link style="position:absolute; right:20px;top:20px;" @click="$router.go(-1)" type="info">返回</el-link>
        <!-- <el-button  type="primary" plain >返回</el-button> -->
        <div class="body">
          <h1 class="header_1">线上诊断报告</h1>
          <el-form ref="diagnosis" :model="diagnosis">
            <el-form-item label="学生姓名：" style="text-align: left">
              <template>
                <span>{{ diagnosis.studentName }}</span>
              </template>
            </el-form-item>
            <el-form-item label="学生年级：" style="text-align: left; margin-top: -20px">
              <template>
                <span>{{ diagnosis.grade }}</span>
              </template>
            </el-form-item>
            <el-form-item label="学生性别：" style="text-align: left; margin-top: -20px">
              <template>
                <span>{{ diagnosis.sexStr }}</span>
              </template>
            </el-form-item>
            <el-form-item label="家庭住址：" style="text-align: left; margin-top: -20px">
              <template>
                <span>{{ diagnosis.address }}</span>
              </template>
            </el-form-item>
            <el-form-item label="家长电话：" style="text-align: left; margin-top: -20px">
              <template>
                <span>{{ diagnosis.parentPhoneNumber }}</span>
              </template>
            </el-form-item>
            <el-form-item label="课程类别：" style="text-align: left; margin-top: -20px">
              <template>
                <span>{{ diagnosis.categoryIdArrToStr }}</span>
              </template>
            </el-form-item>
            <el-form-item label="线上诊断状态：" style="text-align: left; margin-top: -20px">
              <template>
                <span v-if="diagnosis.stautsId == 1">待诊断</span>
                <span v-if="diagnosis.stautsId == 2">已诊断</span>
              </template>
            </el-form-item>
            <!-- <el-form-item
              label="沟通状态："
              style="text-align: left;margin-top: -20px;"
            >
              <template>
                <span v-if="diagnosis.talkId==1">待沟通</span>
                <span v-if ="diagnosis.talkId==2">已沟通</span>
                <span v-if="diagnosis.talkId==3">已收款</span>
              </template>
            </el-form-item> -->
            <el-form-item label="线上诊断老师：" style="text-align: left; margin-top: -20px">
              <template>
                <span>{{ diagnosis.teacherName }}</span>
              </template>
            </el-form-item>
            <el-form-item label="线上诊断时间:" style="margin-top: -20px; text-align: left" label-width="100px">
              <template>
                <!-- diagnosis.startTimeHour1 }}&nbsp;至&nbsp; {{ diagnosis.startTimeHour1 }}</span  -->
                <span>{{ diagnosis.startTimeDay }}&nbsp;&nbsp;&nbsp;&nbsp;{{
                  diagnosis.startTimeHour
                }}&nbsp;至&nbsp; {{diagnosis.startTimeHour1  }}</span>
              </template>
            </el-form-item>
            <!-- <el-form-item
              label="线上诊断费用:"
              style="margin-top: -20px;text-align: left;"
              label-width="100px"
            >
              <template>
                <span>{{ diagnosis.diagnosisPay }}</span>
              </template>
            </el-form-item> -->

            <el-form-item v-if="diagnosis.diagnosisUrl" style="margin-top: -20px; text-align: left" label="下载诊断报告：">
              <template>
                <a :href="diagnosis.diagnosisUrl" target="_blank">下载</a>
              </template>
            </el-form-item>
            <el-form-item label="诊断记录" style="margin-top: -20px"></el-form-item>
            <el-form-item style="margin-left: -77px; margin-top: -22px" label-width="100px">
              <el-form-item v-for="(item, index) in diagnosis.diagnosisDetailArr" :key="index">
                <el-form-item :label="'问题' + (index + 1)" style="text-align: left">
                  <template>
                    <span>{{ item.question }}</span>
                  </template>
                </el-form-item>
                <el-form-item :label="'回答' + (index + 1)" style="text-align: left">
                  <template>
                    <span>{{ item.tips }}</span>
                  </template>
                </el-form-item>
              </el-form-item>
            </el-form-item>
            <el-form-item label="备注：" style="text-align: left">
              <template>
                <span>{{ diagnosis.node }}</span>
              </template>
            </el-form-item>
          </el-form>
        </div>
        <div class="right">
          <h1 class="header_1">线下诊断报告
            <!-- <span style="float: right;" class="el-icon-close" @click="goBack"></span> -->
          </h1>
          <el-form ref="diagnosisOff" :model="diagnosisOff">
            <el-form-item label="学生姓名：" style="text-align: left">
              <!-- <template>
                
              </template> -->
              <span>{{ diagnosisOff.studentName }}</span>
            </el-form-item>
            <el-form-item label="学生年级：" style="text-align: left; margin-top: -20px">
              <!-- <template>
              </template> -->
              <span>{{ diagnosisOff.grade }}</span>
            </el-form-item>
            <el-form-item label="学生性别：" style="text-align: left; margin-top: -20px">
              <!-- <template></template> -->
              <span>{{ diagnosisOff.sexStr }}</span>
            </el-form-item>
            <el-form-item label="家庭住址：" style="text-align: left; margin-top: -20px">
              <!-- <template slot-scope="scope"></template> -->
              <span>{{ diagnosisOff.address }}</span>
            </el-form-item>
            <el-form-item label="家长电话：" style="text-align: left; margin-top: -20px">
              <!-- <template slot-scope="scope"></template> -->
              <span>{{ diagnosisOff.parentPhoneNumber }}</span>
            </el-form-item>
            <el-form-item label="课程类别：" style="text-align: left; margin-top: -20px">
              <!-- <template slot-scope="scope"> </template> -->
              <span>{{ diagnosisOff.categoryIdArrToStr }}</span>
            </el-form-item>
            <el-form-item label="线下诊断状态：" style="text-align: left; margin-top: -20px">
              <!-- <template slot-scope="scope"></template> -->
              <span v-if="diagnosisOff.stautsId == 1">待诊断</span>
              <span v-if="diagnosisOff.stautsId == 2">已诊断</span>
            </el-form-item>
            <el-form-item label="沟通状态：" style="text-align: left; margin-top: -20px">
              <!-- <template slot-scope="scope"></template> -->
              <span v-if="diagnosisOff.talkId == 1">待沟通</span>
              <span v-if="diagnosisOff.talkId == 2">已沟通</span>
              <span v-if="diagnosisOff.talkId == 3">已收款</span>
            </el-form-item>
            <el-form-item label="线下诊断老师：" style="text-align: left; margin-top: -20px">
              <!-- <template> </template> -->
              <span>{{ diagnosisOff.teacherName }}</span>
            </el-form-item>
            <span>
              <el-form-item label="线下诊断时间:" style="margin-top: -20px; text-align: left" label-width="100px">
                <template>
                  <span>{{ diagnosisOff.arr[0] }}&nbsp;&nbsp;&nbsp;&nbsp;{{
                    diagnosisOff.arr[1]
                  }}&nbsp;至&nbsp; {{ diagnosisOff.arr[2] }}</span>
                </template>
              </el-form-item></span>
            <!-- <el-form-item
              label="线下诊断费用:"
              style="margin-top: -20px;text-align: left"
              label-width="100px"
            >
              <template>
                <span>{{ diagnosisOff.diagnosisPay }}</span>
              </template>
            </el-form-item> -->

            <el-form-item v-if="diagnosisOff.diagnosisUrl" style="margin-top: -20px; text-align: left" label="下载诊断报告：">
              <!-- <template slot-scope="scope"> </template> -->
              <a :href="diagnosisOff.diagnosisUrl" target="_blank">下载</a>
            </el-form-item>
            <el-form-item label="诊断记录" style="margin-top: -20px"></el-form-item>
            <el-form-item style="margin-left: -77px; margin-top: -22px">
              <el-form-item v-for="(item, index) in diagnosisOff.diagnosisDetailArr" :key="index" label-width="100px">
                <el-form-item :label="'问题' + (index + 1)" style="text-align: left">
                  <template>
                    <span>{{ item.question }}</span>
                  </template>
                </el-form-item>
                <el-form-item :label="'回答' + (index + 1)" style="text-align: left">
                  <template>
                    <span>{{ item.tips }}</span>
                  </template>
                </el-form-item>
              </el-form-item>
            </el-form-item>
            <el-form-item label="备注：" style="text-align: left">
              <template>
                <span>{{ diagnosisOff.node }}</span>
              </template>
            </el-form-item>
          </el-form>
        </div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";

export default {
  components: {},
  data () {
    return {
      Templates: [], //模板集合
      teachers: [], //老师集合
      rules: {},
      showEdit: false,
      showOff: false,
      //线上诊断数据
      diagnosis: {
        studentName: "",
        stautsId: "",
        talkId: "",
        node: "",
        sexStr: "",
        grade: "",
        categoryIdArrToStr: "", //课程类别
        address: "",
        parentPhoneNumber: "",
        diagnosisId: "",
        teacherName: "",
        templateId: "",
        teacherId: "",
        startTimeDay: "",
        startTimeHour:"",
        startTimeHour1: "",
        diagnosisTimeArr: [],
        customerId: "",
        diagnosisPay: "",
        diagnosisUrl: "",
        diagnosisStatus: "",
        diagnosisType: "",
        diagnosisDetailArr: [
          {
            question: "",
            tips: "",
            answer: "",
          },
        ],
      },
      //线下诊断数据
      diagnosisOff: {
        arr: [],
        studentName: "",
        sexStr: "",
        grade: "",
        address: "",
        stautsId: "",
        talkId: "",
        node: "",
        categoryIdArrToStr: "", //课程类别
        parentPhoneNumber: "",
        tipsTitle: "",
        diagnosisId: "",
        templateId: "",
        teacherId: "",
        startTimeDay: "",
        startTimeour: "",
        startTimeHour1: "",
        diagnosisTimeArr: [],
        customerId: "",
        diagnosisPay: "",
        diagnosisUrl: "",
        diagnosisStatus: "",
        diagnosisType: "",
        diagnosisDetailArr: [
          {
            question: "",
            tips: "",
            answer: "",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  methods: {
    goBack () {
      this.$router.back()
    },
    //初始化
    init (id) {
      this.diagnosis.customerId = id;
      const data = {
        customerId: id,
      };
      axios.post(`${apiBaseUrl}/diagnosis/getList`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then((res) => {
        console.log(res);
        // console.log(res.data.data.length);
        // axios.post(`${apiBaseUrl}/diagnosis/getList`, data).then(res => {
        //   console.log(res.data.data.length);
        if (res.data.data.length > 1) {
          //线上诊断信息
          this.diagnosis.diagnosisId = res.data.data[0].diagnosisId;
          this.diagnosis.sexStr = res.data.data[0].sexStr;
          this.diagnosis.grade = res.data.data[0].gradeIdArrToStr; //年级
          this.diagnosis.categoryIdArrToStr =
            res.data.data[0].categoryIdArrToStr; //课程
          this.diagnosis.address = res.data.data[0].address;
          this.diagnosis.stautsId = res.data.data[0].stautsId;
          this.diagnosis.talkId = res.data.data[0].talkId;
          this.diagnosis.node = res.data.data[0].node;
          this.diagnosis.parentPhoneNumber = parseInt(
            res.data.data[0].parentPhoneNumber
          );
          
          
          this.diagnosis.studentName = res.data.data[0].studentName;
          this.diagnosis.teacherName = res.data.data[0].teacherName;
          this.diagnosis.customerId = res.data.data[0].customerId;
          this.diagnosis.templateId = res.data.data[0].templateId;
          this.diagnosis.teacherId = res.data.data[0].teacherId;
          
  
          this.diagnosis.startTimeDay = JSON.parse(res.data.data[0].diagnosisTime)[0];
          this.diagnosis.startTimeHour = JSON.parse(res.data.data[0].diagnosisTime)[1];
          this.diagnosis.startTimeHour1 = JSON.parse(res.data.data[0].diagnosisTime)[2];

          this.diagnosis.diagnosisUrl = res.data.data[0].diagnosisUrl;
          this.diagnosis.diagnosisPay = res.data.data[0].diagnosisPay;
          this.diagnosis.diagnosisType = res.data.data[0].diagnosisType;
          this.diagnosis.diagnosisStatus = res.data.data[0].diagnosisStatus;
          this.diagnosis.diagnosisDetailArr = JSON.parse(
            res.data.data[0].diagnosisDetail
          );
          //线下诊断
          this.diagnosisOff.diagnosisId = res.data.data[1].diagnosisId;
          this.diagnosisOff.sexStr = res.data.data[0].sexStr;
          this.diagnosisOff.grade = res.data.data[0].gradeIdArrToStr; //年级
          this.diagnosisOff.categoryIdArrToStr =
            res.data.data[0].categoryIdArrToStr; //课程
          this.diagnosisOff.address = res.data.data[0].address;
          this.diagnosisOff.stautsId = res.data.data[1].stautsId;
          this.diagnosisOff.talkId = res.data.data[1].talkId;
          this.diagnosisOff.node = res.data.data[1].node;
          this.diagnosisOff.parentPhoneNumber = parseInt(
            res.data.data[1].parentPhoneNumber
          );
          this.diagnosisOff.studentName = res.data.data[1].studentName;
          this.diagnosisOff.teacherName = res.data.data[1].teacherName;
          this.diagnosisOff.customerId = res.data.data[1].customerId;
          this.diagnosisOff.templateId = res.data.data[1].templateId;
          this.diagnosisOff.teacherId = res.data.data[1].teacherId;
          this.diagnosisOff.arr = JSON.parse(res.data.data[1].diagnosisTime);
          // this.diagnosisOff.startTimeDay = JSON.parse(
          //   res.data.data[0].diagnosisTime
          // )[0];
          // this.diagnosisOff.startTimeHour1 = JSON.parse(
          //   res.data.data[0].diagnosisTime
          // )[2];
          // this.diagnosisOff.startTimeHour = JSON.parse(
          //   res.data.data[0].diagnosisTime
          // )[1];
          this.diagnosisOff.diagnosisUrl = res.data.data[1].diagnosisUrl;
          this.diagnosisOff.diagnosisPay = res.data.data[1].diagnosisPay;
          this.diagnosisOff.diagnosisType = res.data.data[1].diagnosisType;
          this.diagnosisOff.diagnosisStatus = res.data.data[1].diagnosisStatus;
          this.diagnosisOff.diagnosisDetailArr = JSON.parse(
            res.data.data[1].diagnosisDetail
          );
          this.showEdit = true;
          this.showOff = true;
        } else {
          this.diagnosis.diagnosisId = res.data.data[0].diagnosisId;
          this.diagnosis.grade = res.data.data[0].grade;
          this.diagnosis.sex = res.data.data[0].sex;
          this.diagnosis.address = res.data.data[0].address;
          this.diagnosis.studentName = res.data.data[0].studentName;
          this.diagnosis.teacherName = res.data.data[0].teacherName;
          this.diagnosis.customerId = res.data.data[0].customerId;
          this.diagnosis.templateId = res.data.data[0].templateId;
          this.diagnosis.teacherId = res.data.data[0].teacherId;
          this.diagnosis.startTimeDay = JSON.parse(
            res.data.data[0].diagnosisTime
          )[0];
          this.diagnosis.startTimeHour = JSON.parse(
            res.data.data[0].diagnosisTime
          )[1];
          this.diagnosis.startTimeHour1 = JSON.parse(
            res.data.data[0].diagnosisTime
          )[2];
          
          this.diagnosis.diagnosisUrl = res.data.data[0].diagnosisUrl;
          this.diagnosis.diagnosisPay = res.data.data[0].diagnosisPay;
          this.diagnosis.diagnosisType = res.data.data[0].diagnosisType;
          this.diagnosis.diagnosisStatus = res.data.data[0].diagnosisStatus;
          this.diagnosis.diagnosisDetailArr = JSON.parse(
            res.data.data[0].diagnosisDetail
          );
          this.showEdit = true;
        }
      });
    },
    closeOnline () {
      this.$router.push("/offlinediagnosis");
      this.showEdit = false;
    },
    closeEditDialog () {
      this.showOff = false;
    },
    getTeachers () {
      axios
        .get(`${apiBaseUrl}/schedule/teacherlist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.teachers = res.data.data;
        })
        .catch((error) => {
          this.$message({
            message: "获取老师列表失败",
            type: "error",
          });
        });
    },
    getTemplates () {
      const data = {};
      axios.post(`${apiBaseUrl}/template/page`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then((res) => {
        if (res.data.code === 200) {
          this.Templates = res.data.data;
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
    getTemplate (id) {
      axios.get(`${apiBaseUrl}/template/getById/${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then((res) => {
        this.diagnosis.diagnosisDetailArr = JSON.parse(
          res.data.data.templateSet
        );
        this.diagnosis.diagnosisType = res.data.data.templateType + "";
      });
    },
  },
  beforeCreate () { },

  created () {
    this.getTeachers();
    this.getTemplates();
    this.init(this.$route.query.customerId);
  },

  beforeMount () { },

  mounted () { },

  beforeUpdate () { },

  updated () { },

  beforeDestroy () { },
  destroyed () { },

  activated () { },
};
</script>

<style scoped>
.body {
  /* display: flex; */
  margin-left: 10%;
  margin-right: 11%;
  width: 50%;
  text-align: left;
}

.el-main[data-v-0ffd0b22] {
  background-color: #e9eef3 !important;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {

  /* 兼容移动端 */
  #bb>>>.el-dialog {
    width: 83%;
  }
}

.header_1 {
  text-align: left;
  padding-left: 10%;
}

.right {
  margin-right: 10%;
  padding-left: 10%;
  border-left: 15px rgb(223, 221, 221) solid;
  /* flex: auto; */
  width: 50%;
}

/* 隐藏滚动条 */
</style>



// WEBPACK FOOTER //
// src/manager/components/DiagnosisDetail.vue